<template>
    <div class="container">
        <div class="handle-box">
            <div class="handle-left">
                <div class="search-left">

                    <!-- @submit.native.prevent 阻止整个页面路由刷新 -->
                    <el-form :inline="true" label-width="100px" :model="query" class="demo-form-inline" @submit.native.prevent>
                        <el-row>
                            <el-form-item label="审核状态">
                                <el-select v-model="query.apply_status" clearable placeholder="请输入审核状态">
                                    <el-option v-for="(rowitem, index) in statusList" :key="index" :label="rowitem.title" :value="rowitem.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="申请时间">
                                <el-date-picker class="daterange mr10" v-model="query.apply_time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                            </el-form-item>
                            <el-form-item label="审核时间">
                                <el-date-picker class="daterange mr10" v-model="query.apply_confirm_time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                            </el-form-item>
                            <el-form-item label="客资电话">
                                <el-input v-model="query.keyword" type="number" clearable class="handle-input mr10"></el-input>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="派发人">
                                <el-select class="mr10" v-model="query.from_user_id" clearable filterable placeholder="请输入派发人">
                                    <el-option v-for="item in userList" :key="item.id" :label="item.realname" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="外部合作商户">
                                <el-select v-model="query.hotel_id" multiple filterable remote reserve-keyword placeholder="请输入外部合作商户" @focus="focusFn" :remote-method="remoteMethod" :loading="loading" class="popover-left popover-wid">
                                    <el-option v-for="(row,index) in merchants" :key="index" :label="row.title" :value="row.id+''"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-search" native-type="submit" @click="getSearch">搜索</el-button>
                                <el-button type="primary" @click="reset">刷新</el-button>
                                <!-- <el-button type="primary" @click="download">导出</el-button> -->
                            </el-form-item>
                        </el-row>

                    </el-form>
                </div>
            </div>
        </div>
        <!-- 搜索E -->
        <!-- 表格S -->
        <div class="order-detail">
            <el-table :height="tableHeight" :max-height="tableHeight" @selection-change="handleSelectionChange" :data="CustomerData" border ref="multipleTable" highlight-current-row v-loading="loading">
                <el-table-column type="selection" :selectable="selectable">
                </el-table-column>
                <el-table-column prop="visit_amount" show-overflow-tooltip label="审核状态">
                    <template slot-scope="scope">
                        <el-link type="info" v-if="scope.row.apply_status==0">待申请</el-link>
                        <el-link type="info" v-if="scope.row.apply_status==1">待审核</el-link>
                        <el-link type="info" v-if="scope.row.apply_status==2">审核通过</el-link>
                        <el-link type="info" v-if="scope.row.apply_status==3">审核驳回</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="username" align="center" show-overflow-tooltip label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="showDrawerPass(_self, 'auditView', 'showRowlog', [scope.row,'show'])" v-if="scope.row.apply_status==1">立即审核</el-button>
                    </template>
                </el-table-column>
                <!-- 推送人 -->
                <el-table-column prop="from.realname" show-overflow-tooltip label="派发人"> </el-table-column>
                <el-table-column prop="create_time" show-overflow-tooltip label="派发时间"></el-table-column>
                <el-table-column prop="dispatcher.realname" show-overflow-tooltip label="审核人">
                    <template slot-scope="scope">
                        <span v-if="scope.row.dispatcher.id==0">暂无</span>
                        <span v-else>{{scope.row.dispatcher.realname}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="apply_confirm_time" show-overflow-tooltip label="审核时间">
                    <template slot-scope="scope">
                        <span v-if="scope.row.apply_confirm_time==0">暂无</span>
                        <span v-else>{{scope.row.apply_confirm_time}}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="company.title" show-overflow-tooltip label="外部合作商户"></el-table-column>
                <el-table-column prop="applicant.realname" show-overflow-tooltip label="商户申请人">
                    <template slot-scope="scope">
                        <span v-if="scope.row.applicant.id==0">暂无</span>
                        <span v-else>{{scope.row.applicant.realname}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="apply_time" align="center" show-overflow-tooltip label="申请时间"></el-table-column>
                <el-table-column prop="member.realname" show-overflow-tooltip label="客资姓名"></el-table-column>
                <el-table-column prop="member.mobile" show-overflow-tooltip label="客资电话"></el-table-column>
                <el-table-column prop="member.mobile1" show-overflow-tooltip label="其他电话"></el-table-column>
                <el-table-column prop="member.wedding_date" align="center" show-overflow-tooltip label="举办时间"></el-table-column>

            </el-table>
        </div>
        <!-- 表格E -->
        <div class="footer-box">
            <div class="toolBar">
                <el-button type="text" icon="el-icon-share" @click="batchReview">批量审核</el-button>
            </div>
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[10, 15, 30, 50, 100, 300, 1000]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
            </div>
        </div>
        <audit-view ref="auditView" :parent="_self"></audit-view>
    </div>
</template>

<script>
import {
    showDrawerPass,
} from '@/utils/common.js'
import auditView from './audit/index'; // 公海详情
const query = {
    apply_status: "",
    from_user_id: "",
    keyword: "",
    apply_time: "",
    apply_confirm_time: "",
    hotel_id: [], //外部合作商户
};
export default {
    components: {
        auditView
    },
    data() {
        let tableHeight = window.innerHeight - 320;
        let windowheight = window.innerHeight;
        return {
            query: Object.assign({}, query), // 搜索条件
            tableHeight: tableHeight,
            windowheight: windowheight,
            CustomerData: [],
            pagination: {
                page: 1,
                limit: 15,
                total: 0
            },
            options: [],
            value: [],
            list: [],
            loading: false,
            statusList: [{
                id: '0',
                title: '待申请',
            }, {
                id: '1',
                title: '待审核',
            }, {
                id: '2',
                title: '审核通过',
            }, {
                id: '3',
                title: '审核驳回',
            }],
            allocateForm: {
                ids: [],
            },
            userList: [],
            merchants: []
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
    },
    created() {
        this.getTableData()
    },
    mounted() {

    },
    methods: {
        download() {
            let _this = this;
            let url = '/api/wedding.demand/download';
            let options = {};
            options.order_id = _this.order_id,
                options.type = "flower",
                this.$post(url, options).then(res => {
                    if (res.code == '200') {
                        let link = document.createElement('a');
                        link.href = res.data.url;
                        link.click();

                    }
                })

        },
        focusFn() {
            this.remoteMethod(" ")
        },
        remoteMethod(value) {
            let _this = this;
            if (value !== "") {
                _this.loading = true
                setTimeout(() => {
                    _this.loading = false;
                    let url = '/api/merchant.recommend/merchant';
                    let query = {
                        keyword: value,
                    };
                    _this.$post(url, query).then(res => {
                        if (res.code == 200) {
                            _this.merchants = res.data.list
                        }
                    });
                }, 200)
            } else {
                _this.merchants = [];
            }

        },
        selectable(row) {
            if (row.apply_status == 1) {
                return true
            } else {
                return false
            }

        },
        getSearch() {
            let _this = this;
            // var re = /^1\d{10}$/;
            // let str = this.query.keyword;
            // if (re.test(str) || str=='') {} else {
            //     _this.$message.error("抱歉手机号不合法");
            //     return false
            // }
            this.pagination.page = 1;
            this.getTableData();
        },
        getPhone() {

        },
        // 清空筛选项
        reset() {
            this.query = Object.assign({}, query);
        },
        getTableData() {
            let _this = this;
            _this.loading = true;
            let url = "/api/merchant.apply/index";
            let query = {
                ..._this.query
            };
            query['pagination'] = this.pagination;
            this.$post(url, query).then(function (response) {
                if (response.code == 200) {
                    _this.CustomerData = response.data.list;
                    _this.userList = response.data.userList
                    _this.pagination = response.data.pagination;
                    _this.loading = false;
                }
            });
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },

        // 主表选中事件
        handleSelectionChange(e) {
            let ids = [];
            let applyStatus = []
            e.forEach((row, key) => {
                ids.push(row.id);
            });
            this.allocateForm.ids = ids;
        },
        batchReview() {
            this.allocateList = [];
            this.capitalPeople = []; //分配客资（人）
            if (this.allocateForm.ids.length == 0) {
                this.$message({
                    message: '请选择要审核的内容',
                    type: 'warning'
                });
                return false;
            }
            if (this.$refs['auditView']) {
                this.$refs['auditView'].showDialog(this.allocateForm, "batch");
            } else {
                this.$nextTick(() => {
                    this.$refs['auditView'].showDialog(this.allocateForm, "batch");
                })
            }
        }
    }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/member.less');

.handle-box .daterange {
    width: 250px !important;
}

.el-form-item--small.el-form-item {
    margin-bottom: 0 !important;
}
</style>
